export enum AnswerTypes {
    RADIO,
    CHECKBOX,
    SLIDER,
    SKIP
}